var Category;
(function(Category) {
    Category["ContactLenses"] = 'Contact-Lenses';
    Category["Sunglasses"] = "Sunglasses";
    Category["Optical"] = "Optical";
    Category["Accessories"] = "Accessories";
    Category["Solutions"] = "Solutions";
    Category["ReadyReaders"] = 'Ready-readers';
})(Category || (Category = {}));
var LineItemType;
(function(LineItemType) {
    LineItemType["Single"] = 'single';
    LineItemType["Bundle"] = 'bundle';
})(LineItemType || (LineItemType = {}));
var PurchaseType;
(function(PurchaseType) {
    PurchaseType["Subscription"] = 'subscription';
    PurchaseType["OneTime"] = 'one-time';
})(PurchaseType || (PurchaseType = {}));
var EventType;
(function(EventType) {
    EventType["add"] = "add";
    EventType["remove"] = "remove";
    EventType["checkout"] = "checkout";
    EventType["purchase"] = "purchase";
})(EventType || (EventType = {}));

export { Category, EventType, LineItemType, PurchaseType };
//# sourceMappingURL=types.js.map
